export default __webpack_public_path__ + "static/media/logo-small-dark.c8fd2547.svg";